export default "/images/vendor/lightgallery.js/dist/video-play.png?53bb7d07ece69125950d8abb17356920";